import { getBrowserFeatures } from './lib/get-browser.js';
import MobileDetect from 'mobile-detect';

/**
 * Store the oldie check value
 * @type {boolean}
 */
let oldBrowser;

/**
 * Checks whether the current browser is considered 'old'
 * @param {object} configs
 * @param {string} configs.ie - Lowest InternetExplorer version
 * @param {string} configs.firefox - Lowest Firefox version
 * @param {string} configs.chrome - Lowest Chrome version
 * @param {string} configs.safari - Lowest Safari version
 * @returns {boolean}
 */
export function oldBrowserCheck(configs) {
    // return cached browser if available
    if (oldBrowser !== undefined) {
        return oldBrowser;
    }

    let doc = document.documentElement,
        requirements = {
            i: configs.ie,
            f: configs.firefox,
            c: configs.chrome,
            s: configs.safari,
        },
        browserFeatures = getBrowserFeatures(requirements),
        browser = browserFeatures.browser,
        mobileDetect = new MobileDetect(navigator.userAgent);

    oldBrowser = browserFeatures.is_below_required || browser.is_insecure;

    // add the oldie class to the html element when we have an old browser
    if (oldBrowser) {
        doc.classList.add('oldie');
    }

    // store the value in window.oldBrowser
    window.oldie = oldBrowser;

    // ===================================================================
    //                     browser detection helper
    // ===================================================================

    // add the user agent as data attribute
    doc.dataset.useragent = navigator.userAgent;

    // if the user in in an application (like facebook "in app browser")
    // http://stackoverflow.com/questions/31569518/how-to-detect-facebook-in-app-browser#32348687
    doc.dataset.app = navigator.userAgent.indexOf('FBAN') > -1 || navigator.userAgent.indexOf('FBAV') > -1 ? 'fb' : '';

    // add the browser abbreviation as data attribute
    doc.dataset.browser = browser.n;

    if (browser.n === 's') {
        // add the safari data attribute when its Safari
        doc.dataset.safari = browser.v;
    } else if (browser.n === 'i') {
        // add IE data attribute when we have one
        doc.dataset.ie = browser.v;
    } else if (browser.n === 'c') {
        // add Chrome data attribute when we have one
        doc.dataset.chrome = browser.v;
    } else if (browser.n === 'f') {
        // add FF data attribute when we have one
        doc.dataset.ff = browser.v;
    }

    doc.dataset.mobile = mobileDetect.mobile() !== null;
    doc.dataset.tablet = mobileDetect.tablet() !== null;

    return oldBrowser;
}
